import { ToolsTranslations } from '@/lib/translations/types';

export interface ProfitMarginValues { revenue: number; profit: number; }
export interface ProfitMarginResult { percent: number | null; isValid: boolean; message?: string; }

// Profit margin % = Profit / Revenue * 100
export function calculateProfitMargin(values: ProfitMarginValues, t?: ToolsTranslations['profitMargin']): ProfitMarginResult {
  const { revenue, profit } = values;
  if (revenue <= 0) return { percent: null, isValid: false, message: t?.invalid.revenue };
  if (profit < 0) return { percent: null, isValid: false, message: t?.invalid.profit };
  const percent = Math.round((profit / revenue) * 100); // 0 decimals
  if (!isFinite(percent)) return { percent: null, isValid: false, message: t?.invalid.generic };
  return { percent, isValid: true };
}


